import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_frbt34h3nt: FaireBrandEntity = {
  token: "b_frbt34h3nt",
  type: "brand",
  name: "Jangneus",
  avatarUrl:
    "https://cdn.faire.com/fastly/a9ece5c01d832e8ad846e480e7501f5902959267fa60ae0a201a8ea2549809e3.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/8074169049887d1e753307ad5136189fc0433b7ee15cb775182010d3e8284ec0.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/a9ece5c01d832e8ad846e480e7501f5902959267fa60ae0a201a8ea2549809e3.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/8074169049887d1e753307ad5136189fc0433b7ee15cb775182010d3e8284ec0.jpeg",
  location: "Fairfield, CT, USA",
  minimumOrderDollars: 125,
  rating: 5,
  reviewCount: 175,
  isTopShop: true,
  isInsider: true,
  description:
    "Esthetic Living is the US representative for Jangneus - Swedish Kitchen Culture\n\nWith a soul firmly rooted in the heart of the family home in Sweden Jangneus was launched in 2009 with our core product, the Swedish dishcloth.\nThe inspiration for our designs comes from a multitude of places and emotions, especially when visiting our roots in Dalarna, Sweden.\nOur cloths are ultra absorbent, machine washable, long lasting and eco-friendly. The cloths are made from natural and renewable materials; cellulose and cotton and are also 100% biodegradable. The cloths are ideal for washing up, general cleaning and mopping up spills.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:55.848Z",
    importedBy: "entity-db-cli",
  },
};
